import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { FormControl, ValidatorFn, Validators } from '@angular/forms';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';

@Component({
  selector: 'fpx-label',
  templateUrl: './fpx-label.component.html',
  styleUrls: ['./fpx-label.component.scss'],
})
export class FpxLabelComponent implements OnInit {

  @Input() control : FormControl | undefined ;
  @Input() label : string = '';

  required : ValidatorFn = Validators.required
  constructor(private _processShellService: ProcessShellService
  ) {}

  ngOnInit(): void {
  }
}
